module.exports = import("https://www.gstatic.com/firebasejs/10.12.2/firebase-auth.js");;